import * as moment from 'moment';
import {datetimeFormat} from '../../../../config/moment';

export const TimeseriesPlotOptions = ({
  width,
  height,
  seriesLabel,
  seriesData,
  xAxisUnit,
  yAxisUnit,
  xAxisMax,
  xAxisMin,
  yAxisMax,
  yAxisMin,
  showLegend,
}) => ({
  title: {
    text: null,
  },
  chart: {
    width,
    height,
  },
  series: [{
    name: seriesLabel,
    data: seriesData,
    step: 'left',
  }],
  legend: {
    enabled: showLegend,
  },
  xAxis: {
    tickPixelInterval: 150,
    title: {
      text: xAxisUnit,
    },
    min: moment(xAxisMin, datetimeFormat).valueOf(),
    max: moment(xAxisMax, datetimeFormat).valueOf(),
  },
  yAxis: {
    title: {
      text: yAxisUnit,
    },
    min: yAxisMin || yAxisMin === 0 ? Number(yAxisMin) : null,
    max: yAxisMax || yAxisMax === 0 ? Number(yAxisMax) : null,
    endOnTick: false,
    startOnTick: false,
  },
});
